import { http } from 'vue'

export default {
  // load company
  loadCompany (context, params = {}) {
    return http.get('companies')
  },
  saveCompany (context, payload) {
    context.commit('SAVE_COMPANY', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/actions.js